import {MessageCodes} from "../MessageCodes";
import ResultTable from "../../Table/ResultTable";
import ResultText from "../ResultText";
import ComparisonCSName from "../../ComparisonCSName";
const RenderDescription = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Compare.SEC001.error_id: {
            return (
                <>
                    <ResultText>
                        There is a difference in the topography (Station/Elevation data) of the following {row.data.length} cross sections:
                    </ResultText>
                    <ResultText>
                        <ComparisonCSName csNameList={row.data.map(x => x.cross_section)} />
                    </ResultText>
                </>
            )
        }
        case MessageCodes.Compare.SECICS001.error_id: {
            return (
                <>
                    <ResultText>
                        There is a difference in the topography (Station/Elevation data) of the following {row.data.length} Internal Bridge Cross Sections:
                    </ResultText>
                    <ResultText>
                        <ComparisonCSName csNameList={row.data.map(x => x.cross_section)} />
                    </ResultText>
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}

export const C2 = {
    RenderDescription,
}